import React, { useState } from 'react';
import { useAuth } from '../AuthContext'; // Adjusted path
import './ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const { resetPassword } = useAuth();

    const handleReset = async () => {
        if (!email) {
            setError('Please enter a valid email address.');
            return;
        }

        try {
            await resetPassword(email);
            setMessage('Password reset email sent! Please check your inbox.');
            setError('');
        } catch (err) {
            setMessage('');
            setError(err.message);
        }
    };

    return (
        <div className="forgot-password-container">
            <h1>Reset Password</h1>
            <p>Enter your email below, and we’ll send you a link to reset your password.</p>
            <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="forgot-password-input"
            />
            <button onClick={handleReset} className="forgot-password-button">
                Send Reset Email
            </button>
            {message && <p style={{ color: 'green', marginTop: '1rem' }}>{message}</p>}
            {error && <p style={{ color: 'red', marginTop: '1rem' }}>{error}</p>}
        </div>
    );
};

export default ForgotPassword;